export function capitalize(str: string): string {
  return str.replace(/\b\w/g, function(l) {
    return l.toUpperCase();
  });
}

export function getPercentBetween(a: number, b: number): number {
  return b === 0 ? 0 : Math.round((a / b) * 100);
}

export function extractCSS(element: HTMLElement, style: string): string {
  return window.getComputedStyle(element, null).getPropertyValue(style);
}

export function convertStrToBase64(str: string): string {
  const CHARS =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  let out = '';
  let i = 0;
  const len = str.length;
  let c1: number, c2: number, c3: number;
  while (i < len) {
    c1 = str.charCodeAt(i++) & 0xff;
    if (i == len) {
      out += CHARS.charAt(c1 >> 2);
      out += CHARS.charAt((c1 & 0x3) << 4);
      out += '==';
      break;
    }
    c2 = str.charCodeAt(i++);
    if (i == len) {
      out += CHARS.charAt(c1 >> 2);
      out += CHARS.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
      out += CHARS.charAt((c2 & 0xf) << 2);
      out += '=';
      break;
    }
    c3 = str.charCodeAt(i++);
    out += CHARS.charAt(c1 >> 2);
    out += CHARS.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
    out += CHARS.charAt(((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6));
    out += CHARS.charAt(c3 & 0x3f);
  }
  return out;
}

export function hashString(strToHash: string): number {
  return strToHash.split('').reduce((acc, currentChar) => {
    acc = (acc << 5) - acc + currentChar.charCodeAt(0);
    return acc & acc;
  }, 0);
}

export function sortArrayRandomly<T>(array: T[]): T[] {
  const pool = [...array];
  return pool.sort(() => Math.random() - 0.5);
}

export function isStringValid(str: any): boolean {
  return typeof str === 'string' && str != null && str.length > 0;
}

/**
 * String replace using a function to avoid special replacement patterns
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#specifying_a_function_as_the_replacement
 */
export function replacerWithoutPattern(
  inputValue: string,
  searchValue: string | RegExp,
  replaceValue: string
): string {
  return inputValue.replace(searchValue, () => replaceValue);
}

export function compareNb(
  a: number,
  b: number,
  precision: number = 2
): boolean {
  const factor = Math.pow(10, precision);
  return (
    Math.round(a * factor) >= Math.round(b * factor) - 2 &&
    Math.round(a * factor) <= Math.round(b * factor) + 2
  );
}

export function getCenterCoordinates(
  element: HTMLElement | null
): [number, number] {
  if (!element) {
    throw new Error('Impossible to get center coordinates of element');
  }
  const rect = element.getBoundingClientRect();
  return [rect.left + rect.width / 2, rect.top + rect.height / 2];
}

export function truncate2Digits(value: number): number {
  if (typeof value !== 'number' || isNaN(value)) return 0;
  return Math.trunc(value * 100) / 100;
}
